import { useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { permissionError } from "../../../util/Alert";
import Button from "../../extra/Button";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import {
  createWithdraw,
  updateWithdraw,
} from "../../store/withdraw/withdraw.action";

const getDetailIcon = (item) => {
  const value = String(item || "").toLowerCase();
  if (value.includes("@")) return "fa-solid fa-location-arrow";
  if (/^\d[\d\s-]{6,}$/.test(value.replace(/\s/g, ""))) {
    return "fa-solid fa-mobile-screen-button";
  }
  return "fa-solid fa-wallet";
};

const WithdrawDialog = (props) => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const [mongoId, setMongoId] = useState("");
  const [name, setName] = useState();
  const [image, setImage] = useState([]);
  const [imagePath, setImagePath] = useState("");

  const [detail, setDetail] = useState("");
  const [addDetail, setAddDetail] = useState([]);

  const [error, setError] = useState({
    name: "",
    imagePath: "",
    addDetail: "",
  });

  const fileInputRef = useRef(null);

  useEffect(() => {
    setMongoId(dialogueData?._id);
    setName(dialogueData?.name);
    setImagePath(dialogueData?.image);
    setAddDetail(
      Array.isArray(dialogueData?.details) ? dialogueData.details : []
    );
  }, [dialogueData]);
  const dispatch = useDispatch();

  const handleImage = (e) => {
    setImage(e.target.files[0]);
    setImagePath(URL.createObjectURL(e.target.files[0]));
    setError((prevErrors) => ({
      ...prevErrors,
      image: "",
    }));
  };
  const addCountryList = (e) => {
    e.preventDefault();
    setAddDetail((old) => {
      if (!Array.isArray(old)) {
        old = [];
      }
      return [...old, detail];
    });
    setDetail("");
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      addCountryList(event);
    }
  };

  const onRemove = (id) => {
    setAddDetail((old) => {
      if (!Array.isArray(old)) {
        old = [];
      }
      return old.filter((array, index) => {
        return index !== id;
      });
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!hasPermission) return permissionError();
    if (!name || !image || addDetail?.length === 0) {
      let error = {};
      if (!name) error.name = "Name is required!";
      if (addDetail?.length === 0) error.addDetail = "Details are required!";

      setError({ ...error });
    } else {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("image", image);
      for (let i = 0; i < addDetail?.length; i++) {
        formData.append("details", addDetail[i]);
      }

      if (mongoId) {
        props.updateWithdraw(formData, mongoId);
      } else {
        props.createWithdraw(formData);
      }

      dispatch({ type: CLOSE_DIALOGUE });
    }
  };

  const detailsCount = Array.isArray(addDetail) ? addDetail.length : 0;
  const fileName =
    image && typeof image === "object" && image.name
      ? image.name
      : imagePath
      ? "Image selected"
      : "No file chosen";

  return (
    <div className="mainDialogue fade-in">
      <div className="Dialogue withdraw-dialogue">
        <div className="dialogueHeader withdraw-dialogue__header">
          <div className="withdraw-dialogue__title-wrap">
            <div className="withdraw-dialogue__icon">
              <i className="fa-solid fa-wallet"></i>
            </div>
            <div>
              <div className="headerTitle fw-bold withdraw-dialogue__title">
                Withdraw
              </div>
              <p className="withdraw-dialogue__subtitle mb-0">
                Add or update withdrawal method details
              </p>
            </div>
          </div>
          <div
            className="closeBtn withdraw-dialogue__close"
            onClick={() => {
              dispatch({ type: CLOSE_DIALOGUE });
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>

        <div className="dialogueMain withdraw-dialogue__body">
          {/* Name */}
          <div className="withdraw-field">
            <label className="withdraw-field__label" htmlFor="name">
              Name <span className="withdraw-required">*</span>
            </label>
            <div className="withdraw-input-wrap">
              <i className="fa-regular fa-user withdraw-input-wrap__icon"></i>
              <input
                id="name"
                type="text"
                className="withdraw-input"
                placeholder="Enter Name"
                value={name || ""}
                onChange={(e) => {
                  setName(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      name: `Name Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      name: "",
                    });
                  }
                }}
              />
            </div>
            <p className="withdraw-helper">
              Enter the withdrawal method name (e.g. Google Pay, PhonePe,
              JioFinance, etc.)
            </p>
            {error.name && <p className="errorMessage">{error.name}</p>}
          </div>

          {/* Enter Detail */}
          <div className="withdraw-field">
            <div className="withdraw-field__label-row">
              <label className="withdraw-field__label mb-0" htmlFor="detail">
                Enter Detail <span className="withdraw-required">*</span>
              </label>
              <span className="withdraw-field__hint">
                <i className="fa-solid fa-circle-info"></i>
                Add multiple details
              </span>
            </div>
            <div className="withdraw-detail-row">
              <div className="withdraw-input-wrap flex-grow-1">
                <i className="fa-regular fa-credit-card withdraw-input-wrap__icon"></i>
                <input
                  id="detail"
                  type="text"
                  className="withdraw-input"
                  placeholder="Enter detail (e.g. mobile number, UPI ID, wallet ID)"
                  value={detail}
                  onChange={(e) => {
                    setDetail(e.target.value);
                  }}
                  onKeyPress={handleKeyPress}
                />
              </div>
              <button
                type="button"
                className="withdraw-add-btn"
                onClick={addCountryList}
                disabled={detail === ""}
              >
                + Add
              </button>
            </div>
            <p className="withdraw-helper">
              You can add multiple details (e.g. mobile number, UPI ID, wallet
              ID, etc.)
            </p>
            {error.addDetail && (
              <p className="errorMessage">{error.addDetail}</p>
            )}
          </div>

          {/* Added Details */}
          {detailsCount > 0 && (
            <div className="withdraw-field">
              <label className="withdraw-field__label">
                Added Details ({detailsCount})
              </label>
              <div className="withdraw-chips">
                {addDetail?.map((item, id) => (
                  <span className="withdraw-chip" key={`${item}-${id}`}>
                    <i className={getDetailIcon(item)}></i>
                    <span className="withdraw-chip__text">{item}</span>
                    <i
                      className="fa-solid fa-xmark withdraw-chip__remove"
                      onClick={() => {
                        onRemove(id);
                      }}
                    ></i>
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Image */}
          <div className="withdraw-field mb-0">
            <label className="withdraw-field__label">
              Image <span className="withdraw-required">*</span>
            </label>
            <div
              className="withdraw-upload"
              onClick={() => fileInputRef.current?.click()}
            >
              <div className="withdraw-upload__icon">
                <i className="fa-regular fa-image"></i>
              </div>
              <div className="withdraw-upload__text">
                <span className="withdraw-upload__choose">Choose File</span>
                <span className="withdraw-upload__name">{fileName}</span>
              </div>
              <input
                ref={fileInputRef}
                id="image"
                type="file"
                accept="image/*"
                className="d-none"
                onChange={(e) => handleImage(e)}
              />
            </div>
            <p className="withdraw-helper">
              Upload the payment method logo (recommended size: 512 × 512 px)
            </p>
            {error.image && <p className="errorMessage">{error.image}</p>}
            {imagePath && (
              <div className="image-start withdraw-preview">
                <img
                  src={imagePath}
                  alt="banner"
                  draggable="false"
                  width={100}
                  className="m-0"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/defaultImage.png";
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="dialogueFooter withdraw-dialogue__footer">
          <div className="dialogueBtn">
            <Button
              btnName={`Close`}
              btnColor="myCustomButton"
              style={{ borderRadius: "8px", minWidth: "90px" }}
              newClass={`me-2`}
              onClick={() => {
                dispatch({ type: CLOSE_DIALOGUE });
              }}
            />
            <Button
              btnName={`Submit`}
              btnColor={`btnBlackPrime text-light`}
              // btnIcon="fa-solid fa-paper-plane"
              style={{ borderRadius: "8px", minWidth: "110px" }}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { createWithdraw, updateWithdraw })(
  WithdrawDialog
);
